export const pageRoutes = {
  '/cart': 'CART',
  '/myCoupons': 'COUPONS',
  '/product': 'PDP',
  '/category': 'PLP',
  '/search': 'PLP',
  '/membership': 'MEMBERSHIP',
  // '/membershipEnroll': 'MEMBERSHIP',
};

export const excludedPaths = ['/image'];

export const mfeDataPath = {
  header: 'headerMfe/GetInitialData',
  footer: 'footerMfe/GetInitialData',
  static: 'staticMfe/GetInitialData',
  membership: 'membershipMfe/GetInitialData',
  plp: 'plpMfe/GetInitialData',
  pdp: 'pdpMfe/GetInitialData',
};

export const MEMBERSHIP_ROUTE = '/membership';
export const CSR_API = '/mfe-static/csr-data';

export const localImportMaps = {
  imports: {
    headerMfe: 'http://localhost:3001/',
    staticMfe: 'http://localhost:3002/',
    footerMfe: 'http://localhost:3003/',
    sharedMfe: 'http://localhost:3004/',
    membershipMfe: 'http://localhost:3005/',
    cartMfe: 'http://localhost:3006/',
    couponsMfe: 'http://localhost:3007/',
    plpMfe: 'http://localhost:3008/',
    pdpMfe: 'http://localhost:3009/',
  },
};

export const defaultMfes = [
  'headerMfe',
  'staticMfe',
  'footerMfe',
  'couponsMfe',
  'plpMfe',
  'cartMfe',
  'pdpMfe',
];
export const membershipMfes = ['headerMfe', 'footerMfe', 'membershipMfe'];
export const CONTENT_TYPE = 'Content-Type';
export const APPLICATION_JSON = 'application/json';

export const isMembership = (req: any) => {
  const url = req?.body?.originalUrl ? req?.body?.originalUrl : req?.originalUrl;
  return url?.toLowerCase()?.startsWith(MEMBERSHIP_ROUTE);
};

export const FALLBACK_ORIGIN = 'https://www.bjs.com';
export const STATUS_FULFILLED = 'fulfilled';

export const CACHE_KEYS = {
  FOOTER: 'footerData',
  HEADER: 'headerData',
  HOME: 'homePageData',
};
